// ---------- timeline data ----------
const timelineElements = [
    {
        id: 1,
        Degree: "8th - 10th",
        Name: "Ravindra Bharathi School",
        Location: "Srikakulam",
        description: "Completed my 10th standard in 2019 from Ravindra Bharathi School with an excellent CGPA of 9.3, showcasing consistency and strong academic performance.",
        date: "2016 - 2019",
        icon: "school"
    },
    {
        id: 2,
        Degree: "Intermediate (MPC)",
        Name: "Sri Chaitanya Junior College",
        Location: "Srikakulam",
        description: "Successfully completed my Intermediate (MPC) in 2021 with a CGPA of 8.3, building a solid foundation in mathematics and science.",
        date: "2019 - 2021",
        icon: "school"
    },
    {
        id: 3,
        Degree: "Bachelor of Technology (B.Tech) in CSE (AI & ML)",
        Name: "Avanthi Institute of Engineering and Technology",
        Location: "Vizianagaram",
        description: "Graduated in 2025 with a B.Tech degree in Computer Science and Engineering specializing in Artificial Intelligence and Machine Learning, achieving a CGPA of 8.31. Gained expertise in AI/ML, software development, and full-stack technologies.",
        date: "2021 - 2025",
        icon: "school"
    }
];

export default timelineElements;